<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
    :class="[
      'font-weight-medium text-uppercase text-body-1 button-widget',
      secondary ? 'grey--text text--darken-4' : 'white--text',
    ]"
    :color="!secondary ? '#5F86BC' : 'secondary'"
    :min-width="minWidth"
    height="44px"
    depressed
    tile
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    secondary: {
      type: Boolean,
      default: false,
    },
    minWidth: {
      type: String,
      default: "202px",
    },
  },
};
</script>

<style lang="scss" scoped>
.button-widget {
  letter-spacing: 0.15em !important;
}
</style>
